const getUTMParametersFromCookies = () => {
  const cookies = document.cookie.split(";").reduce((acc, cookie) => {
    const [key, value] = cookie.trim().split("=")
    acc[key] = value
    return acc
  }, {})

  return {
    utm_source: cookies.utmSource || "",
    utm_medium: cookies.utmMedium || "",
    utm_campaign: cookies.utmCampaign || "",
    source_refer: cookies.sourceRefer || "",
  }
}

export default getUTMParametersFromCookies
